// extracted by mini-css-extract-plugin
export default {"providerLogo":"ProviderImage_providerLogo--eAk","label":"ProviderImage_label--fOX"};